export const DefaultLocaleId: number = 1;